import { createStore } from 'redux';
import reducers from './reducers';

export const makeStore = ( preloadedState ) =>
	createStore( reducers, preloadedState );

const store = makeStore();

export default store;
